import { apiGeneral } from './_General';

export const apiListSecondaryQuizQuestions = {
  getQuizQuestions(cb, eCb) {
    apiGeneral.apiFetch('public/list_secondary_quiz_questions', {
      $orderby: 'question_number'
    }, null, cb, eCb);
  }
};
